<template>
    <div class="card-container">
        <ListHeader title="三级维度指标" >
            <template slot="right">
                <ActionButton/>
            </template>
        </ListHeader>
        <div class="content">
            <div class="score">
                <Score />
            </div>
            <div class="divider"></div>
            <div class="text-content">
                教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习
                要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师
                通过引导学生猜测自己的名字由来，激发学生的表达动机，并自然过渡到学习如何讲述
                自己名字背后的故事，这与课文主题高度一致;
                教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习
                要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师
                通过引导学生猜测自己的名字由来，激发学生的表达动机，并自然过渡到学习如何讲述
                自己名字背后的故事，这与课文主题高度一致;
                教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习
                要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师
                通过引导学生猜测自己的名字由来，激发学生的表达动机，并自然过渡到学习如何讲述
                自己名字背后的故事，这与课文主题高度一致;
            </div>
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import ActionButton from './ActionButton.vue';
export default {
    name: 'ReportStyle2',
    components: {
        ListHeader,
        Score,
        ActionButton
    },
    data() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.card-container {
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;
    width: 100%;
    max-width: 100%;
    position: relative;

    .content {
        height: 220px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        min-width: 0;

        .score {
            /* 增加内边距而不是固定宽度 */
            width: 124px;
            height: 108px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .divider {
            width: 1px;
            height: 180px;
            background: #043B6A;
            margin: 0 20px;
        }

        .text-content {
            font-family: Alibaba PuHuiTi 3.0;
            font-size: 14px;
            font-weight: normal;
            line-height: 200%;
            letter-spacing: 0em;
            color: #7BA8D0;
            /* 添加滚动功能 */
            max-height: 180px;
            overflow-y: auto;
            /* 确保文本自动换行 */
            word-wrap: break-word;
            word-break: break-all;
            white-space: normal;
            /* 强制限制宽度 */
            width: 100%;
            flex: 1;
            min-width: 0;
            box-sizing: border-box;
            overflow-wrap: break-word;
            hyphens: auto;
            flex-shrink: 1;
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(0, 28, 53, 0.2);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(5, 133, 247, 0.5);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: rgba(5, 133, 247, 0.8);
            }
        }
    }
}
</style>